import { WorkflowDataDto } from '@asset-metrix/portal-gateway-client-js';
import { useMutation } from '@tanstack/react-query';

import { executeWorkflowAction } from '../api/portalGateway/workflowAction';

export function useWorkflowAction() {
  const { mutateAsync, error, reset, status } = useMutation({
    mutationFn: executeWorkflowAction,
  });
  return {
    error,
    status,
    reset,
    executeAction: (
      contentId: string,
      action: string,
      data: WorkflowDataDto
    ) => {
      return mutateAsync({ contentId, action, data });
    },
  };
}
